import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const events = {
  onClick: preventEventBubblingFn
  // other events not required because they are not "double triggered"
};

/**
 * This helper components prevents event bubbling for label elements
 * => Important when labels are connected with inputs by using htmlFor (double events)
 * @param props
 * @constructor
 */
export function LabelWithoutEventBubbling(props) {
  return /*#__PURE__*/_jsx("label", {
    ...props,
    ...events
  });
}
function preventEventBubblingFn(event) {
  event.stopPropagation();
}